'use strict';

import RSA from "./dist/main.min.js";
export default RSA;